/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import { dispatchClearARSummaryByQtrAllData } from '../../ARSummaryByQtrAll/store/actions';

export const allAccRecNDCDetail = (data) => ({
  type: actiontypes.ALL_ACC_REC_NDC__DETAIL_TABLE,
  getAllAccRecNDCDetailList: data,
});
export const ndcDetail = (data) => ({
  type: actiontypes.NDC_DETAIL,
  ndcDetailList: data,
});

export const dispatchClearAccRecNDCDetailAllData = (val) => {
  return {
    type: actiontypes.ACC_REC_NDC_DETAIL_ALL_FIELD_CLEAR_REDUX,
    payload: val,
  };
};

export const clearAccRecNDCDetailAllPage = () => (dispatch, getState) => {
  const reduxObj = getState()?.sharedState?.ArSummaryQtrAllReducer;
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  let changePass = false;
  let newObj1 = {};
  if (!_.isEmpty(updateTabs)) {
    const newObj = _.cloneDeep(reduxObj);
    if (
      updateTabs.filter(
        (x) =>
          x.navTo === '/arSummaryByQtrAll' || x.navTo === '/ARSummaryByQtrAll'
      ).length === 0
    ) {
      changePass = true;
      newObj1 = {};
    }
  } else {
    newObj1 = {};
    changePass = true;
  }
  if (changePass) {
    dispatch(dispatchClearARSummaryByQtrAllData(newObj1));
  }
  dispatch(dispatchClearAccRecNDCDetailAllData({}));
};
